import React from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import ButtonWrapper, { LOG_IN, SIGN_UP } from '../ButtonWrapper';

const GoogleButton = ({ type, onClick }) => {
  const I18nPrefix = 'strava.landing_page';

  return (
    <ButtonWrapper
      className={styles.googleButton}
      onClick={onClick}
      data-testid="google_auth_btn"
    >
      {type === SIGN_UP
        ? I18n.t(`${I18nPrefix}.here_to_join.google_cta`)
        : 'implement_me'}
    </ButtonWrapper>
  );
};

GoogleButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf([SIGN_UP, LOG_IN]).isRequired
};

GoogleButton.defaultProps = {
  onClick: () => {}
};

export default GoogleButton;
